import { AbstractController } from "controllers/abtract-controller"

export class CsvEventController extends AbstractController {
    protected path = "/events"

    public async uploadCsv(csv: string): Promise<boolean> {
        return this.doPostRequest("/parsingCsvEvent", { csv: csv })
    }
}
